import React, { Component } from "react";
import { Table, Container, Segment } from "semantic-ui-react";

import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

export const getDefaultFiber = () => ({
  FB1: {
    channel2: 0,
    channel3: 0,
    signal: false,
    statusChannel2: "",
    statusChannel3: ""
  },
  FB2: {
    channel2: 0,
    channel3: 0,
    signal: false,
    statusChannel2: "",
    statusChannel3: ""
  }
});

export const getDefaultFiberChannelActive = () => ({
  FB1: {
    channel2Active: false,
    channel3Active: false,
    signalActive: false
  },
  FB2: {
    channel2Active: false,
    channel3Active: false,
    signalActive: false
  }
});

export const normalizeFiber = (fiber) => ({
  FB1: {
    ...getDefaultFiber().FB1,
    ...(fiber && typeof fiber.FB1 === "object" ? fiber.FB1 : {})
  },
  FB2: {
    ...getDefaultFiber().FB2,
    ...(fiber && typeof fiber.FB2 === "object" ? fiber.FB2 : {})
  }
});

export const normalizeFiberChannelActive = (fiberChannelActive) => ({
  FB1: {
    ...getDefaultFiberChannelActive().FB1,
    ...(fiberChannelActive && typeof fiberChannelActive.FB1 === "object" ? fiberChannelActive.FB1 : {})
  },
  FB2: {
    ...getDefaultFiberChannelActive().FB2,
    ...(fiberChannelActive && typeof fiberChannelActive.FB2 === "object" ? fiberChannelActive.FB2 : {})
  }
});

export class OpticFiber extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      channel2FB1: 0,
      channel3FB1: 0,
      signalFB1: false,
      channel2ActiveFB1: false,
      channel3ActiveFB1: false,
      signalActiveFB1: false,
      statusChannel2FB1: "",
      statusChannel3FB1: "",
      channel2FB2: 0,
      channel3FB2: 0,
      signalFB2: false,
      channel2ActiveFB2: false,
      channel3ActiveFB2: false,
      signalActiveFB2: false,
      statusChannel2FB2: "",
      statusChannel3FB2: "",
      fiberIntervalID: -1
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(normalizeFiber)
        .catch((error) => {
          console.log(error);
          return getDefaultFiber();
        })
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberChannelActive", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(normalizeFiberChannelActive)
        .catch((error) => {
          console.log(error);
          return getDefaultFiberChannelActive();
        })
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      channel2FB1: resolvedPromisses[0].FB1.channel2,
      channel3FB1: resolvedPromisses[0].FB1.channel3,
      signalFB1: resolvedPromisses[0].FB1.signal,
      statusChannel2FB1: resolvedPromisses[0].FB1.statusChannel2,
      statusChannel3FB1: resolvedPromisses[0].FB1.statusChannel3,
      signalActiveFB1: resolvedPromisses[1].FB1.signalActive,
      channel2ActiveFB1: resolvedPromisses[1].FB1.channel2Active,
      channel3ActiveFB1: resolvedPromisses[1].FB1.channel3Active,
      channel2FB2: resolvedPromisses[0].FB2.channel2,
      channel3FB2: resolvedPromisses[0].FB2.channel3,
      signalFB2: resolvedPromisses[0].FB2.signal,
      statusChannel2FB2: resolvedPromisses[0].FB2.statusChannel2,
      statusChannel3FB2: resolvedPromisses[0].FB2.statusChannel3,
      signalActiveFB2: resolvedPromisses[1].FB2.signalActive,
      channel2ActiveFB2: resolvedPromisses[1].FB2.channel2Active,
      channel3ActiveFB2: resolvedPromisses[1].FB2.channel3Active,
    });

  };

  getVoltageValue = (value) => {
    const voltage = value !== null ? value.toFixed(2).replace(".", ",") : "";
    return voltage.concat(Strings.VOLTAGE);
  }

  getSignalTable = (FB) => {
    if (FB === 1) {
      if (this.state.signalFB1 && this.state.signalActiveFB1) {
        return (
          <Table striped celled fixed singleLine textAlign="center" size="small" style={signalTableStyle}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{Strings.RELAY_STATUS}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell verticalAlign="middle" style={okCellStyle}>
                  {Strings.OK}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        );
      }
      else if ((!this.state.signalFB1 && this.state.signalActiveFB1)) {
        return (
          <Table striped celled fixed singleLine textAlign="center" size="small" style={signalTableStyle}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{Strings.RELAY_STATUS}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell verticalAlign="middle" style={badCellStyle}>
                  {Strings.FAULT}
                </Table.Cell>
              </Table.Row >
            </Table.Body>
          </Table>
        );
      }
    } else {
      if (this.state.signalFB2 && this.state.signalActiveFB2) {
        return (
          <Table striped celled fixed singleLine textAlign="center" size="small" style={signalTableStyle}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{Strings.RELAY_STATUS}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell verticalAlign="middle" style={okCellStyle}>
                  {Strings.OK}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        );
      }
      else if ((!this.state.signalFB2 && this.state.signalActiveFB2)) {
        return (
          <Table striped celled fixed singleLine textAlign="center" size="small" style={signalTableStyle}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>{Strings.RELAY_STATUS}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell verticalAlign="middle" style={badCellStyle}>
                  {Strings.FAULT}
                </Table.Cell>
              </Table.Row >
            </Table.Body>
          </Table>
        );
      }
    }
  }

  getChannelTableRow = (channel, isChannelActive, FB) => {

    if (FB === 1) {
      if (isChannelActive && channel === 2) {
        return (
          <Table.Row>
            <Table.Cell verticalAlign="middle">{Strings.CHANNEL_2}</Table.Cell>
            <Table.Cell verticalAlign="middle">{this.getVoltageValue(this.state.channel2FB1)}</Table.Cell>
            {this.createStatusCell(this.state.statusChannel2FB1)}
          </Table.Row>
        );
      }
      else if (isChannelActive && channel === 3) {
        return (
          <Table.Row>
            <Table.Cell verticalAlign="middle">{Strings.CHANNEL_3}</Table.Cell>
            <Table.Cell verticalAlign="middle">{this.getVoltageValue(this.state.channel3FB1)}</Table.Cell>
            {this.createStatusCell(this.state.statusChannel3FB1)}
          </Table.Row>
        );
      }
    } else {
      if (isChannelActive && channel === 2) {
        return (
          <Table.Row>
            <Table.Cell verticalAlign="middle">{Strings.CHANNEL_2}</Table.Cell>
            <Table.Cell verticalAlign="middle">{this.getVoltageValue(this.state.channel2FB2)}</Table.Cell>
            {this.createStatusCell(this.state.statusChannel2FB2)}
          </Table.Row>
        );
      }
      else if (isChannelActive && channel === 3) {
        return (
          <Table.Row>
            <Table.Cell verticalAlign="middle">{Strings.CHANNEL_3}</Table.Cell>
            <Table.Cell verticalAlign="middle">{this.getVoltageValue(this.state.channel3FB2)}</Table.Cell>
            {this.createStatusCell(this.state.statusChannel3FB2)}
          </Table.Row>
        );
      }
    }
  }

  createStatusCell = (StatusChannel) => {
    if (StatusChannel === Constants.GOOD) {
      return (
        <Table.Cell
          style={okCellStyle}>
          {Strings.GOOD_STRING}
        </Table.Cell>
      );
    }
    else if (StatusChannel === Constants.ATTENTION) {
      return (
        <Table.Cell
          style={attentionCellStyle}>
          {Strings.ATTENTION_STRING}
        </Table.Cell>
      );
    }
    else if (StatusChannel === Constants.BAD) {
      return (
        <Table.Cell
          style={badCellStyle}>
          {Strings.BAD_STRING}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          style={unknownCellStyle}>
          {Strings.UNKNOWN_STRING}
        </Table.Cell>
      );
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ fiberIntervalID: setInterval(() => { this.retrieveData(); }, 1000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.fiberIntervalID);
  }

  render() {
    return (
      <Container>
        <Segment>
          <div style={fiberSectionTitleStyle}>{Strings.OPTIC_FIBER + " 1"}</div>
          <Table striped celled fixed singleLine textAlign="center">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell disabled>{Strings.CHANNEL}</Table.HeaderCell>
                <Table.HeaderCell disabled>{Strings.SIGNAL_QUALITY}</Table.HeaderCell>
                <Table.HeaderCell disabled>{Strings.STATUS}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.getChannelTableRow(2, this.state.channel2ActiveFB1, 1)}
              {this.getChannelTableRow(3, this.state.channel3ActiveFB1, 1)}
            </Table.Body>
          </Table>
          {this.getSignalTable(1)}
        </Segment>
        <div style={fiberDividerStyle} />
        <Segment>
          <div style={fiberSectionTitleStyle}>{Strings.OPTIC_FIBER + " 2"}</div>
          <Table striped celled fixed singleLine textAlign="center">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell disabled>{Strings.CHANNEL}</Table.HeaderCell>
                <Table.HeaderCell disabled>{Strings.SIGNAL_QUALITY}</Table.HeaderCell>
                <Table.HeaderCell disabled>{Strings.STATUS}</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.getChannelTableRow(2, this.state.channel2ActiveFB2, 2)}
              {this.getChannelTableRow(3, this.state.channel3ActiveFB2, 2)}
            </Table.Body>
          </Table>
          {this.getSignalTable(2)}
        </Segment>
      </Container>
    );
  }
}

const okCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const attentionCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const badCellStyle = {
  color: "black",
  backgroundColor: "#FF5722",
  verticalAlign: "middle"
};

const unknownCellStyle = {
  color: "black",
  backgroundColor: "lightgrey",
  verticalAlign: "middle"
};

const signalTableStyle = {
  marginTop: "18px",
  width: "100%",
  maxWidth: "360px",
  marginLeft: "auto",
  marginRight: "auto"
};

const fiberSectionTitleStyle = {
  fontSize: "18px",
  fontWeight: "bold",
  marginBottom: "12px",
  textAlign: "center"
};

const fiberDividerStyle = {
  borderTop: "1px solid #D9D9D9",
  margin: "32px 0 20px"
};

export default OpticFiber;